export default __webpack_public_path__ + "static/media/warrantyManagement2-2.d66ce11e.png";